/* Display variant images */

function showVariantImage(ev) {
  const productId = ev.target.dataset.product;
  const variantId = ev.target.dataset.variant;
  const variantSku = ev.target.dataset.sku;
  const variantSameColourVariants = ev.target.dataset.sameColourVariants;
  const searchTerms = document.querySelector('.template-search__header').dataset.searchTerm.toLowerCase();
  const variantBadge = ev.target.dataset.variantBadges;
  const variantBadgePosition = ev.target.dataset.badgePosition;

  // To solve the issue of searching SKU doesn't show appropriate product if product has same colour variants
  let variantSkuDisplay = variantSku;
  let variantIdDisplay = variantId;
  const variantSameColourVariantsArray = variantSameColourVariants.split(',');
  let alreadyMatched = false;
  variantSameColourVariantsArray.forEach((variantData) => {
    const variantDataArray = variantData.split('/');
    const variantDataSku = variantDataArray[0];
    const variantDataId = variantDataArray[1];
    const variantDataOptions = variantDataArray[2].toLowerCase();
    if (variantDataOptions.includes(searchTerms) || variantDataSku.includes(searchTerms)) {
      variantSkuDisplay = variantDataSku;
      variantIdDisplay = variantDataId;
      ev.target.setAttribute('data-sku', variantDataSku);
      ev.target.setAttribute('data-variant', variantDataId);
      matches = true;
    };

    if (alreadyMatched === true) {
      return;
    };
  });

  // loop over all product card images and make them opaque, except for the selected one
  const cardImages = document.querySelectorAll(`.product-card-${productId} .card-product-image`)
  
  if (cardImages.length > 1 ) {
    cardImages.forEach((img) => {
      const imgVariantId = img.dataset.variant;
  
      if (imgVariantId === variantId) {
        img.classList.remove('image-hover');
        img.classList.add('image-variant-hover');
      } else {
        img.classList.add('image-hover');
        img.classList.remove('image-variant-hover');
      }
    });
  }

  // update the SKU and the anchor link of selected variant 
  const productCard = document.querySelector(`.product-card-${productId}`);

  if (productCard) {
    const variantSkuValue = productCard.querySelector('.product__sku .sku');
    const variantLink = productCard.closest('.full-unstyled-link.main-link');

    if (variantSkuValue) {
      variantSkuValue.innerHTML = variantSkuDisplay;
    }

    if (variantLink) {
      const productUrl = variantLink.dataset.cardHandle;
      const variantUrl = productUrl + '?variant=' + variantIdDisplay;
      variantLink.setAttribute('href', variantUrl);
    }
  }

  //display the variant badges
  plpDisplayVariantBadges(variantBadge, variantBadgePosition, productCard);
}

function hideVariantImage(ev) {
  const productId = ev.target.dataset.product;
  const variantId = ev.target.dataset.variant;

  // loop over all product card images and make them opaque, except for the selected one
  document.querySelectorAll(`.product-card-${productId} .card-product-image)`).forEach((img) => {
    if (img.dataset.secondaryImage) {
      return;
    }

    const imgVariantId = img.dataset.variant;

    if (imgVariantId === variantId) {
      img.classList.remove('image-variant-hover');
    } else {
      img.classList.remove('image-hover');
    }
  });
}

document.querySelectorAll('.card-variant--container .color-swatch').forEach((card) => {
  card.addEventListener('click', showVariantImage);
  // card.addEventListener('mouseleave', hideVariantImage);
});

//Init product card variant to first variant
function InitProductCardVariant() {
  const swatchContainers = document.querySelectorAll('.card-variant--container');
  setTimeout(() => {
    swatchContainers.forEach((card) => {
      const options = card.querySelectorAll('.swatch-input');
      // Temporarily disable page scrolling during click operation
      const originalScrollPos = window.scrollY; // Store the current scroll position
      
      options.forEach((option) => {
        if (option.checked) {
          const option_id = option.id;
          const option_label = card.querySelector(`label[for="${option_id}"]`);
          option_label.click();
        };
      });
      // Re-enable page scrolling after click operation
      window.scrollTo(0, originalScrollPos);
	  })
  }, 500);
}
domReady(InitProductCardVariant);

const plpDisplayVariantBadges = (variantBadge, variantBadgePosition, productCard) => {
  // Remove existing js added badges
  const existingJsBadges = productCard.querySelectorAll('.js-card__badge');
  if (existingJsBadges) {
    existingJsBadges.forEach((badge) => {
      badge.remove();
    });
  };
  //Add new badges
  if (!variantBadge) return;
  const variantBadgeArray = variantBadge.split(',');
  const badgeContainer = productCard.querySelector('.card__badge--container');
  const badgeAcount = badgeContainer.querySelectorAll('.card__badge--container .card__badge').length;
  if (badgeAcount >=  2) return;
  for (let i = badgeAcount; i < 2; i++) {
    if (variantBadgeArray[i]) {
      const badge = `
        <div class="card__badge js-card__badge ${variantBadgePosition}">
          <span class="badge badge--bottom-left color-background-2">${variantBadgeArray[i]}</span>
        </div>`;
      badgeContainer.insertAdjacentHTML('beforeend', badge);
    };
  };
};

function applyFilter(ev) {
  const toggleURL = ev.target.dataset.toggleUrl;
  const filterTag = ev.target.dataset.tag;
  let targetUrl = '';

  const keepDrawerOpen =
    ev.target.closest('[data-mobile-facets-inner]') && typeof FacetFiltersForm !== 'undefined';

  if (toggleURL) {
    const paramName = ev.target.name;
    const paramValue = ev.target.value;
    if (paramName && paramValue !== undefined) {
      const parsed = new URL(window.location.href);
      if (keepDrawerOpen && typeof FacetFiltersForm !== 'undefined' && FacetFiltersForm.searchParamsPrev != null) {
        const qp = FacetFiltersForm.searchParamsPrev;
        if (qp) {
          parsed.search = `?${qp}`;
        }
      }
      if (ev.target.checked) {
        parsed.searchParams.set(paramName, paramValue);
      } else {
        parsed.searchParams.delete(paramName);
      }
      targetUrl = parsed.toString();
    } else {
      targetUrl = toggleURL.startsWith('http') ? toggleURL : `${window.location.origin}${toggleURL}`;
    }
  } else if (filterTag) {
    const currentCollection = ev.target.dataset.collection;
    const loc = document.location;
    const pathForTags =
      keepDrawerOpen &&
      typeof FacetFiltersForm !== 'undefined' &&
      FacetFiltersForm.pendingCollectionPathname
        ? FacetFiltersForm.pendingCollectionPathname
        : loc.pathname;
    const pathMatch = pathForTags.match(/^\/collections\/([^/]+)(?:\/(.*))?$/);
    const currentTagsStr = pathMatch ? (pathMatch[2] || '') : '';
    let newPathName = '';

    if (ev.target.checked) {
      const newTags = currentTagsStr ? `${currentTagsStr}+${filterTag}` : filterTag;
      newPathName = `/collections/${currentCollection}/${newTags}`;
    } else {
      newPathName = pathForTags
        .replace(filterTag, '')
        .replace(/\++/g, '+')
        .replace(/\/\+/g, '/')
        .replace(/\+$/g, '')
        .replace(/\/$/g, '');
    }

    const searchSuffix =
      keepDrawerOpen &&
      typeof FacetFiltersForm !== 'undefined' &&
      FacetFiltersForm.searchParamsPrev != null
        ? FacetFiltersForm.searchParamsPrev
          ? `?${FacetFiltersForm.searchParamsPrev}`
          : loc.search
        : loc.search;

    targetUrl = `${loc.protocol}//${loc.host}${newPathName}${searchSuffix}`;
  } else {
    return;
  }

  if (keepDrawerOpen) {
    FacetFiltersForm.renderPageFromUrl(targetUrl, ev);
  } else {
    location.href = targetUrl;
  }
}

domReady(() => {
  document.addEventListener('change', (ev) => {
    if (!ev.target.matches('.filter-toggle')) return;
    applyFilter(ev);
  });
});